import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { Loader } from "@/components/common";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Properties from "@/pages/Properties";
import Tenants from "@/pages/Tenants";
import Leases from "@/pages/Leases";
import Landlords from "@/pages/Landlords";
import Invoices from "@/pages/Invoices";
import Payments from "@/pages/Payments";
import Commissions from "@/pages/Commissions";
import Expenses from "@/pages/Expenses";
import Inspections from "@/pages/Inspections";
import Inventory from "@/pages/Inventory";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Companies from "@/pages/Companies";
import Vouchers from "@/pages/Vouchers";
import Notifications from "@/pages/Notifications";
import Audit from "@/pages/Audit";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function LoginGate() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

const R = (el) => <Protected>{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/" element={R(<Dashboard />)} />
          <Route path="/properties" element={R(<Properties />)} />
          <Route path="/tenants" element={R(<Tenants />)} />
          <Route path="/leases" element={R(<Leases />)} />
          <Route path="/landlords" element={R(<Landlords />)} />
          <Route path="/invoices" element={R(<Invoices />)} />
          <Route path="/payments" element={R(<Payments />)} />
          <Route path="/commissions" element={R(<Commissions />)} />
          <Route path="/vouchers" element={R(<Vouchers />)} />
          <Route path="/expenses" element={R(<Expenses />)} />
          <Route path="/inspections" element={R(<Inspections />)} />
          <Route path="/inventory" element={R(<Inventory />)} />
          <Route path="/reports" element={R(<Reports />)} />
          <Route path="/settings" element={R(<Settings />)} />
          <Route path="/staff" element={R(<Users />)} />
          <Route path="/users" element={R(<Users />)} />
          <Route path="/companies" element={R(<Companies />)} />
          <Route path="/notifications" element={R(<Notifications />)} />
          <Route path="/audit" element={R(<Audit />)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
